<form [formGroup]="form" (ngSubmit)="onSubmit()" class="card integration-settings-form">
  <div class="card-body">
    <div class="mb-3">
      <div class="d-flex align-items-center gap-2">
        <p-toggleswitch
          formControlName="streamingEnabled"
          inputId="callRecordingStreamingEnabled"></p-toggleswitch>
        <label for="callRecordingStreamingEnabled" class="form-label mb-0">
          {{ 'Settings::CallRecordingStreamingEnabled' | abpLocalization }}
        </label>
      </div>
      <small class="form-text text-muted">
        {{ 'Settings::CallRecordingStreamingEnabledDescription' | abpLocalization }}
      </small>
    </div>

    <div class="mb-3">
      <label for="streamingWssUrl" class="form-label">
        {{ 'Settings::CallRecordingStreamingWssUrl' | abpLocalization }}
      </label>
      <input
        id="streamingWssUrl"
        type="text"
        class="form-control"
        formControlName="streamingWssUrl"
        placeholder="wss://recorder.example.com/stream"
        [class.is-invalid]="isControlInvalid('streamingWssUrl')" />
      <div class="invalid-feedback" *ngIf="hasError('streamingWssUrl', 'required')">
        {{ 'Settings::CallRecordingStreamingWssUrl' | abpLocalization }}
        {{ '::Required' | abpLocalization }}
      </div>
      <div class="invalid-feedback" *ngIf="hasError('streamingWssUrl', 'pattern')">
        {{ getWebSocketUrlInvalidMessage() }}
      </div>
      <small
        class="form-text text-muted"
        *ngIf="!isControlInvalid('streamingWssUrl')">
        {{ 'Settings::CallRecordingStreamingWssUrlDescription' | abpLocalization }}
      </small>
    </div>
  </div>

  <div class="integration-settings-form__footer">
    <cx-form-actions
      layout="inline"
      [showCancel]="false"
      [saveLabel]="isSubmitting ? ('::Saving' | abpLocalization) : ('::Save' | abpLocalization)"
      [disabled]="isSubmitting"
      [isSubmitting]="isSubmitting">
    </cx-form-actions>
  </div>
</form>
